import { render, staticRenderFns } from "./surveyCampaign2.vue?vue&type=template&id=c4c5873c"
import script from "./surveyCampaign2.vue?vue&type=script&lang=js"
export * from "./surveyCampaign2.vue?vue&type=script&lang=js"
import style0 from "./surveyCampaign2.vue?vue&type=style&index=0&id=c4c5873c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports